export default function () {
  return {
    loggedIn: false
  };
}
